import clsx from 'clsx';
import React from 'react';

import ProSection from '@components/pages/DualSubscribe/ProSection';
import BenefitCluster from '@components/pages/SubscribeTest/OfferSelection/Clusters';
import SubscriptionBenefitsSection from '@components/pages/SubscribeTest/SubscriptionBenefitsSection';
import useModifiedBenefits from '@hooks/useModifiedBenefits';
import { OfferOption, Reporter, SelectedOffer } from '@utils/backend-api/subscribe';

import CompaniesAndLeaders from './CompaniesAndLeaders';
import Experts from './Experts';
import Header from './Header';
import OfferCards from './OfferCards';
import OfferTable from './OfferTable';
import { BENEFIT_ROWS, MONTHLY, THE_INFORMATION_DIFFERENCE } from './constants';

export interface OfferSelectionProps {
  isGiftLanding?: boolean;
  latestTITVEpisodeID?: string;
  offers: OfferOption[];
  offerTitleClass?: string;
  onOfferClick: () => void;
  reporters?: Reporter[];
  setSelectedOffer?: (plan: SelectedOffer) => void;
  ypOffer?: OfferOption;
}

const OfferSelection = ({
  isGiftLanding,
  latestTITVEpisodeID,
  offers,
  onOfferClick,
  reporters,
  setSelectedOffer,
  ypOffer,
}: OfferSelectionProps) => {
  const modifiedBenefits = useModifiedBenefits(
    offers.find(({ billingFrequency }) => billingFrequency === MONTHLY),
    offers.find(({ billingFrequency, isPro }) => !isPro && billingFrequency !== MONTHLY),
    offers.find(({ isPro }) => !!isPro)
  );

  return (
    <>
      <div
        className={clsx('px-16 pt-32 sm:px-28', {
          'sm:pt-48': isGiftLanding,
          'sm:pt-64': !isGiftLanding,
        })}
      >
        <div className="m-auto max-w-full md:max-w-[1174px]">
          <Header isGiftLanding={isGiftLanding} />
          <OfferTable
            benefits={modifiedBenefits}
            offers={offers}
            onOfferClick={onOfferClick}
            setSelectedOffer={setSelectedOffer}
            isGiftLanding={isGiftLanding}
          />
          {ypOffer && (
            <>
              <OfferCards
                onOfferClick={onOfferClick}
                setSelectedOffer={setSelectedOffer}
                ypOffer={ypOffer}
              />
            </>
          )}

          {!isGiftLanding && (
            <>
              <SubscriptionBenefitsSection
                benefits={BENEFIT_ROWS}
                title={THE_INFORMATION_DIFFERENCE}
              />
              <BenefitCluster latestTITVEpisodeID={latestTITVEpisodeID} />
              <CompaniesAndLeaders />
            </>
          )}
        </div>
        {!isGiftLanding && (
          <>
            {reporters.length > 0 && <Experts reporters={reporters} />}
            <div className="pt-64 lg:pt-112">
              <ProSection />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OfferSelection;
